import { Descriptions } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLevelUpStudents } from '../../../api/semesters.api';
import { getEvaluationPeriod } from '../../../api/tutor.api';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { IClass } from '../../../models/campusClasses.model';
import { IGetLevelUpStudents } from '../../../models/semesters.model';
import { IGetEvaluationPeriod } from '../../../models/tutor.model';
import LevelUpTable from '../../class/level-up/LevelUpTable';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Pagination from '../../Pagination';

interface IProps {
  classData: IClass | undefined;
}

const Level: FC<IProps> = ({ classData }) => {
  const { t } = useTranslation();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetEvaluationPeriod>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetLevelUpStudents>();

  const [pageNo, setPageNo] = useState(1);
  console.log(classData, ';classData');
  useEffect(() => {
    if (classData) {
      execute(getEvaluationPeriod(classData.classCode));
    }
  }, [classData]);

  useEffect(() => {
    doGetLevelUpStudents();
  }, [pageNo]);

  const doGetLevelUpStudents = () => {
    if (!classData) return;

    execute2(
      getLevelUpStudents({
        classCode: classData.classCode,
        semesterCode: classData?.semesterCode,
        pageNo,
        perPage: config.pageSize,
      }),
    );
  };

  return (
    <>
      {(isLoading || isLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <div className="comm-table__area rowType mt-1">
        <Descriptions
          bordered
          column={3}
          size="small"
          labelStyle={{ width: '16.6%' }}
          contentStyle={{ width: '16.6%' }}
        >
          <Descriptions.Item label={t('class.tutor.column17')}>
            {classData?.courseDetailName}
          </Descriptions.Item>
          <Descriptions.Item label={t('class.tutor.column18')}>
            {classData?.courseName}
          </Descriptions.Item>
          <Descriptions.Item label={t('class.tutor.column19')}>
            {classData?.courseSubName}
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="mt-4 text-right">
        {t('class.tutor.text1')}:{' '}
        {moment(res?.data?.evaluationSrtDate).format('YYYY.MM.DD')} ~{' '}
        {moment(res?.data?.evaluationEndDate).format('YYYY.MM.DD')}
      </div>

      <div className="mt-4 comm-table__area">
        <LevelUpTable
          data={res2?.data}
          doGetLevelUpStudents={doGetLevelUpStudents}
        />
      </div>
      <div className="common-paging">
        <Pagination
          count={res2?.total || 0}
          page={pageNo}
          setPage={setPageNo}
        />
      </div>
    </>
  );
};

export default Level;
